// An app's chat in cortex's preview (ADR 0021 amendment of 2026-10-08): the bridge a framed app's own chat UI asks,
// and where a saved chat report opens.
import type { AppChatBridgeHost } from '@cortex/app-shell';
import { APP_REACH_HEADER, api, apiBaseUrl, getAccessToken } from '../platform/index.ts';
import { config } from '../platform/index.ts';

export /** A saved chat report's page on cortex: under the project branch it was saved on. */
const reportPathOf = (slug: string, branch: string, id: string) =>
  `/p/${encodeURIComponent(slug)}/b/${encodeURIComponent(branch)}/chat-report?id=${encodeURIComponent(id)}`;

/**
 * The headless chat of a framed app (ADR 0021 amendment of 2026-10-08): the app's own chat UI asks this page,
 * which answers with cortex's chat client named by the app, as the Data analyst (useAppChatBridge).
 */
export const appChatBridge = (branch: string): AppChatBridgeHost => ({
  apiBaseUrl,
  assistantBaseUrl: config.VITE_ASSISTANT_BASE_URL,
  getToken: () => getAccessToken(),
  // The turn reads this preview's branch (cortex's turn route takes it beside the chat's own fields).
  turnFields: { branch },
  companions: async (slug, app) => {
    const r = await api.GET('/api/structure/projects/{slug}/branches/{branch}/apps/{app}/companions', {
      params: { path: { slug, branch, app } },
      headers: { [APP_REACH_HEADER]: app },
    });
    return r.data ?? null;
  },
  reportPath: (slug, id) => reportPathOf(slug, branch, id),
});
